import React, { Component } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Field } from 'react-final-form'
import { MenuItem } from '@material-ui/core'
import { Select } from 'components/common/FormInputs'
import { setActiveSite } from 'reducers/projectedSitesManager/reducer'
import getValidator, { VALIDATOR_IS_EMPTY } from 'validation'
import { ONE_YEAR_IN_MONTHES } from 'constants/index'
import messages from '../translate'

class MonthYearSelect extends Component {
  isDateEnabled = date => {
    const { isHarvesting, dateToCompare } = this.props

    if (!dateToCompare) {
      return true
    }

    const [month, year] = date.split('-')
    const [monthToCompare, yearToCompare] = dateToCompare.split('-')

    if (isHarvesting) {
      return !(
        Number(year) < Number(yearToCompare) ||
        (Number(year) === Number(yearToCompare) &&
          Number(month) < Number(monthToCompare))
      )
    }

    return !(
      Number(year) > Number(yearToCompare) ||
      (Number(year) === Number(yearToCompare) &&
        Number(month) > Number(monthToCompare))
    )
  }

  getDatesBeforeActive = (activeDate, countMonthes) => {
    let [month, year] = activeDate.split('-')
    const resultArr = []

    for (let i = 0; i < countMonthes; i += 1) {
      let date

      if (month - 1 > 0) {
        const extraZero = month <= 10 ? '0' : ''
        date = `${extraZero}${month - 1}-${year}`

        month -= 1
      } else {
        month = 12
        date = `${month}-${year - 1}`

        year -= 1
      }

      resultArr.push({
        date,
        enabled: this.isDateEnabled(date),
      })
    }

    return resultArr.reverse()
  }

  getDatesAfterActive = (activeDate, countMonthes) => {
    const [month, year] = activeDate.split('-')
    let monthInt = Number.parseInt(month, 10)
    let yearInt = Number.parseInt(year, 10)
    const resultArr = []

    for (let i = 0; i < countMonthes; i += 1) {
      let date

      if (monthInt + 1 <= 12) {
        const extraZero = monthInt < 9 ? '0' : ''
        date = `${extraZero}${monthInt + 1}-${yearInt}`

        monthInt += 1
      } else {
        monthInt = 1
        date = `0${monthInt}-${yearInt + 1}`

        yearInt += 1
      }

      resultArr.push({
        date,
        enabled: this.isDateEnabled(date),
      })
    }

    return resultArr
  }

  getSelectItems = () => {
    let { activeDate } = this.props
    const {
      numberOfMonthBeforeDate = ONE_YEAR_IN_MONTHES,
      numberOfMonthAfterDate = ONE_YEAR_IN_MONTHES,
    } = this.props

    if (!activeDate) {
      activeDate = moment().format('MM-YYYY')
    }

    const datesBefore = this.getDatesBeforeActive(
      activeDate,
      numberOfMonthBeforeDate,
    )
    const datesAfter = this.getDatesAfterActive(
      activeDate,
      numberOfMonthAfterDate,
    )
    const currentDate = [
      {
        date: activeDate,
        enabled: this.isDateEnabled(activeDate),
      },
    ]

    return [...datesBefore, ...currentDate, ...datesAfter]
  }

  onChangeDate = value => {
    if (value) {
      const { activeDate, fieldName, setActiveSite } = this.props

      if (activeDate !== value) {
        setActiveSite({ [fieldName]: value })
      }
    }

    return value
  }

  render() {
    const {
      intl: { formatMessage },
      fieldName,
    } = this.props
    const dates = this.getSelectItems()

    return (
      <div className="form-group">
        <Field
          required
          name={fieldName}
          component={Select}
          label={formatMessage(messages[fieldName])}
          formControlProps={{
            fullWidth: true,
            required: true,
          }}
          validate={getValidator([VALIDATOR_IS_EMPTY])}
          parse={value => this.onChangeDate(value)}>
          {dates.map(({ date, enabled }) => (
            <MenuItem key={date} value={date} disabled={!enabled}>
              {date}
            </MenuItem>
          ))}
        </Field>
      </div>
    )
  }
}

export default connect(null, {
  setActiveSite,
})(injectIntl(MonthYearSelect))
